var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagPy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26626_59423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 61.61H139.13V92.42H0.5V61.61Z",
    fill: "#253B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 30.8101H139.13V61.6201H0.5V30.8101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H139.13V30.81H0.5V0Z",
    fill: "#D01317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5301 46.21C81.5301 52.68 76.2901 57.92 69.8201 57.92C63.3501 57.92 58.1101 52.68 58.1101 46.21C58.1101 39.74 63.3501 34.5 69.8201 34.5C76.2901 34.5 81.5301 39.74 81.5301 46.21Z",
    stroke: "#101010",
    strokeWidth: 0.168,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1102 45.6599C62.3902 44.5299 61.5402 44.6299 60.6502 44.5299L60.5902 45.0699C61.4902 45.1699 61.7502 45.1199 61.7202 45.4099C61.6902 45.6799 61.5202 45.5999 60.5402 45.4999L60.4802 46.0499C61.3102 46.1299 61.9602 46.3299 62.1102 45.6599Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2603 48.09L61.8603 48.22L62.1103 48.98L61.9103 49.04L61.6803 48.36L61.3203 48.49L61.5403 49.17L61.4003 49.22L61.1603 48.48L60.7803 48.61L61.1903 49.87L62.6803 49.36L62.2603 48.09Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5403 50.0199L76.2603 50.4899L76.8203 50.8299L77.3003 51.8299L77.6103 51.2999L77.3503 50.8299L77.8903 50.8199L78.2002 50.2899L77.1003 50.3599L76.5403 50.0199Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1403 47.28L61.5903 47.34C61.5703 47.12 61.5603 46.86 61.3803 46.7C61.1403 46.5 60.4803 46.53 60.5503 47.19L60.6503 48L62.2003 47.82L62.1403 47.28ZM61.1503 47.16C61.1903 47.2 61.2003 47.32 61.2103 47.38L60.9603 47.41L60.9503 47.32C60.9303 47.13 61.0703 47.09 61.1503 47.16Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3203 42.8399C62.1603 42.7799 62.0003 42.8099 61.8903 42.9399C61.8103 42.6099 61.2803 42.4699 61.1003 42.9999L60.8003 43.8599L62.2803 44.3799C62.5503 43.5999 62.8503 43.0199 62.3203 42.8399ZM61.3403 43.4599C61.3603 43.4099 61.4103 43.2299 61.4603 43.1999C61.5103 43.1799 61.5803 43.1999 61.6003 43.2499C61.6203 43.2999 61.5503 43.4699 61.5303 43.5199L61.3403 43.4599ZM61.8703 43.6499C61.9203 43.5099 61.9603 43.2899 62.0903 43.3399C62.2303 43.3799 62.1203 43.5899 62.0703 43.7199L61.8703 43.6499Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8902 43.01L77.1402 42.99L77.3002 43.43L77.1002 43.58L77.3002 44.12L78.5702 43.02L78.3802 42.49L76.7102 42.47L76.8902 43.01ZM77.6402 43.17L77.5702 42.97L77.9302 42.95L77.6402 43.17Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8103 45.8299L78.5003 45.7399L78.4003 44.9399L78.0103 44.9999L78.0503 45.3099L77.9803 45.3199C77.5603 44.7199 78.3503 44.6299 78.5403 44.7499C78.6803 44.8499 78.7203 45.0899 78.5103 45.1999L78.6703 45.7099C79.3003 45.4599 79.1703 44.4399 78.6103 44.2199C77.7703 43.8599 76.9403 44.7999 77.8103 45.8299Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2103 48.3299L77.4203 48.4799L77.2703 48.9199L77.0103 48.9099L76.8303 49.4599L78.5003 49.4099L78.6903 48.8799L77.4003 47.7999L77.2103 48.3299ZM77.6903 48.9399L77.7603 48.7399L78.0503 48.9599L77.6903 48.9399Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0903 46.82L79.1503 46.28C78.3303 46.19 77.6803 45.97 77.5203 46.65C77.3003 47.76 77.9403 47.67 78.9803 47.79L79.0403 47.25C78.0803 47.14 77.8803 47.18 77.9103 46.91C77.9403 46.6 78.2103 46.71 79.0903 46.82Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7903 42.0399L61.8403 41.4599L61.5503 41.9299L62.9003 42.7499L63.5403 41.6599L63.1603 41.4299L62.7903 42.0399Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3401 37.01L67.6301 37.11L67.8501 38.67L68.5701 38.57C69.5601 38.42 69.3101 36.88 68.3401 37.01ZM68.3201 38.18L68.2201 37.46C68.3201 37.45 68.4401 37.42 68.5201 37.49C68.6201 37.58 68.7101 38.01 68.5701 38.12C68.5201 38.16 68.3901 38.17 68.3201 38.18Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5403 38.3899L70.8603 38.4899L70.9003 38.0699L70.1103 38.0099L70.1203 37.7999L70.8303 37.8499L70.8603 37.4699L70.1503 37.4099L70.1603 37.2599L70.9303 37.3199L70.9603 36.9099L69.6503 36.8199L69.5403 38.3899Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7203 50.7199C62.6503 50.5999 62.7403 50.5299 63.0203 50.0499L62.7103 49.5199C62.6203 49.6699 62.3303 50.0699 62.3303 50.2499C62.0103 50.0099 61.3303 50.2699 61.7503 50.9999L62.1603 51.6999L63.5103 50.8899L63.2303 50.4199L62.7203 50.7199ZM62.4103 50.8999L62.2203 51.0099C62.0003 50.6399 62.1603 50.4899 62.4103 50.8999Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3203 38.0799L65.5003 39.7499L66.0003 39.4899L65.9503 39.2399L66.3603 39.0299L66.5403 39.2199L67.0503 38.9599L65.8103 37.8199L65.3203 38.0799ZM66.0703 38.7299L65.8803 38.8299L65.8203 38.4699L66.0703 38.7299Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0002 39.1899L74.4802 39.8999L74.8802 40.2999L75.1002 40.1799L75.4302 40.4999L75.3102 40.7299L75.7202 41.1399L76.4002 39.5899L76.0002 39.1899ZM75.4802 39.9699L75.8002 39.7999L75.6302 40.1299L75.4802 39.9699Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0601 37.13L71.5401 36.98L71.1201 38.5L72.3201 38.85L72.4501 38.42L71.7601 38.22L72.0601 37.13Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5303 40.4499L63.7203 41.4699L64.0703 41.0499L62.8803 40.0299L62.5303 40.4499Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6902 38.3L74.0201 37.85L73.1602 39.17L73.6102 39.47L73.9102 39.01C74.8802 39.66 75.2502 38.67 74.6902 38.3ZM74.1301 38.68L74.2602 38.47C74.5702 38.69 74.4401 38.89 74.1301 38.68Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0501 39.4199L64.5901 39.6199C64.6301 39.6999 64.6701 39.7699 64.6701 39.8699C64.6701 39.9699 64.5301 40.1099 64.3901 40.0799C64.2601 40.0599 64.0301 39.7799 64.0101 39.6399C63.9901 39.4699 64.1601 39.2699 64.4201 39.4399L64.7201 39.0399C64.0801 38.6299 63.5301 39.2499 63.5001 39.6399C63.4701 40.0099 63.8101 40.4299 64.1101 40.5299C64.6801 40.6999 65.3901 40.1399 65.0501 39.4199Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3303 42.03L76.6603 42.55C76.8003 42.31 77.0203 41.97 77.0103 41.81C77.3103 42.03 78.0303 41.77 77.5603 41.05L77.1303 40.37L75.8103 41.22L76.1003 41.68L76.6103 41.35C76.6803 41.47 76.6003 41.54 76.3303 42.03ZM76.9203 41.15L77.1003 41.03C77.1803 41.15 77.3003 41.3 77.1903 41.37C77.0803 41.45 76.9903 41.26 76.9203 41.15Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.62 46.2399C79.62 51.6599 75.23 56.0499 69.81 56.0499C64.39 56.0499 60 51.6599 60 46.2399C60 40.8299 64.39 36.4399 69.81 36.4399C75.23 36.4399 79.62 40.8299 79.62 46.2399Z",
    stroke: "#101010",
    strokeWidth: 0.084,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.11 46.2099C77.11 50.2399 73.84 53.5099 69.81 53.5099C65.78 53.5099 62.51 50.2399 62.51 46.2099C62.51 42.1799 65.78 38.9199 69.81 38.9199C73.85 38.9099 77.11 42.1799 77.11 46.2099Z",
    stroke: "#101010",
    strokeWidth: 0.084,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8201 43.58L70.4301 45.33L72.2801 45.37L70.8001 46.49L71.3401 48.27L69.8101 47.21L68.2801 48.27L68.8101 46.49L67.3301 45.37L69.1901 45.33L69.8201 43.58Z",
    fill: "#F2D635",
    stroke: "#101010",
    strokeWidth: 0.084,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2 52.24C71 52.2 71.39 51.94 71.8 52.05C72.21 52.15 71.74 52.43 71.2 52.24Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7501 50.24C67.5801 49.97 67.2101 49.47 67.1101 48.63C67.1001 48.52 66.5301 48.9 66.9501 49.75C67.1701 50.2 67.9501 50.64 67.6201 50.5C67.2701 50.35 66.9001 50.25 66.6101 49.38C66.2601 48.35 66.7301 48.66 66.6801 47.15C66.6701 46.98 66.2901 47.55 66.2201 47.78C66.1101 48.15 66.0401 48.53 66.4901 49.48C66.5301 49.56 66.3301 49.41 66.2401 49.18C65.6601 47.64 66.5901 46.13 65.7601 47.33C65.4701 47.75 65.9701 48.83 66.1201 49.19C66.1601 49.29 65.6401 48.31 65.5601 47.98C65.0801 46.01 66.0201 46.34 65.7901 45.14C65.7101 44.74 65.7301 45.04 65.6001 45.36C65.3001 46.07 64.8401 46.21 65.2201 47.36C65.5001 48.22 64.5101 46.63 65.0201 45.65C65.6101 44.52 67.3501 43.65 67.0701 43.68C66.9101 43.7 65.5601 43.73 65.0901 45.14C65.0601 45.22 65.0001 45.19 65.0401 45.1C65.5201 43.93 66.1801 43.55 67.0201 43.05C67.6601 42.66 67.6201 42.26 67.5501 42.31C66.6301 43.01 66.5401 42.06 65.4001 44.02C65.2701 44.24 65.2401 44.15 65.3101 44.01C65.9401 42.6 66.2201 42.88 67.0501 42.28C67.5901 41.89 68.5001 40.96 68.3201 40.95C67.1001 40.92 66.0201 42.87 65.8001 42.94C65.7401 42.96 66.1501 42.48 66.2301 42.3C66.7801 41.14 66.5001 41.27 66.8301 40.89C66.8901 40.82 65.9101 41.06 65.7701 42.54C65.7501 42.72 65.0301 44.25 65.0601 44.05C65.0801 43.93 65.0201 43.08 65.5301 42.06C66.1401 40.86 65.5301 41.75 65.3301 42.01C64.4901 43.1 64.6901 45.91 64.6101 45.74C64.2701 44.96 64.9401 43.12 64.3401 42.29C64.2401 42.16 64.2901 42.33 64.3301 42.55C64.4501 43.22 63.8001 43.56 64.3701 45.91C64.4301 46.16 64.0901 44.86 63.3101 45.14C63.0901 45.22 63.5801 45.2 64.2001 45.93C64.3801 46.15 64.1701 46.66 64.3801 46.88C65.3701 47.89 65.9801 49.22 65.7501 48.91C65.2601 48.26 63.4901 46.07 63.6501 46.55C64.1101 47.96 64.5401 47.56 65.5301 48.89C65.7901 49.24 66.4501 49.73 66.5401 49.96C66.5701 50.02 65.6101 49.22 65.3601 49.05C65.1601 48.92 64.7301 48.72 64.2201 48C64.0701 47.78 64.2501 49.04 65.2201 49.62C65.3801 49.72 66.1001 50.08 67.2001 50.56C67.4401 50.66 65.2901 50.13 64.8401 49.85C64.5401 49.66 65.0801 50.89 66.7301 50.87C67.6301 50.86 67.0101 50.68 69.3201 51.47C69.6101 51.57 70.7901 51.92 71.1501 52.2C71.1501 52.2 71.3701 51.97 71.8901 52.07C71.3801 51.6 68.4201 51.34 67.7501 50.24Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8601 52.1701C67.7501 52.2701 68.5201 52.3801 68.6701 52.2201C68.7201 52.1601 68.0001 52.0501 67.8601 52.1701Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3901 48.83C74.3901 48.83 74.7101 48.58 74.9301 48.52C75.7001 48.31 75.6401 47.54 76.0301 46.98C75.5601 47.03 75.5301 47.79 75.0201 48.05C74.5601 48.28 74.5201 48.56 74.3901 48.83Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.89 42.3601C73.77 42.3401 73.65 42.3801 73.36 42.5501C73.03 42.7401 72.53 42.4001 72.26 42.6301C73.01 42.8101 73.18 42.9501 73.66 42.5601C73.79 42.4601 73.89 42.3601 73.89 42.3601Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.77 50.15C73.77 50.15 73.94 50.16 74.15 50.15C74.92 50.13 74.98 49.87 75.53 49.12C75.09 49.12 74.9 49.81 74.43 49.91C74.01 49.99 73.87 50.04 73.77 50.15Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8401 41.22C72.8001 41.77 73.2201 42.11 73.2001 42.27C72.8701 41.92 72.3901 40.85 71.3701 40.88C71.3201 40.88 71.3001 40.83 71.4401 41.16C71.7701 41.93 72.6701 42.09 73.0101 42.19C73.0501 42.2 73.1401 42.39 73.1201 42.38C72.2301 41.97 71.9601 41.94 71.4801 42.02C71.3801 42.04 71.2801 42.05 71.3101 42.06C71.3301 42.07 71.6501 42.52 73.1701 42.51C73.7201 42.49 74.4401 43.99 74.4601 44.02C74.5001 44.09 74.7001 44.13 74.5301 43.92C74.5001 43.88 73.8301 42.54 73.4301 42.24C73.7401 41.5 73.2701 41.13 73.0901 40.99C72.7001 40.69 72.8801 40.73 72.8401 41.22Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.76 41.11C74.26 41.57 74.26 42.17 74.24 42.61C74.22 43 74.35 43.12 74.09 42.69C73.97 42.49 73.54 41.89 73.7 41.28C73.75 41.12 73.76 41.11 73.76 41.11Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4901 44.3C72.9201 44.3 72.8201 43.41 72.6101 43.02C72.4201 42.67 72.5901 43.03 73.0801 43.17C73.5401 43.3 73.9701 43.75 74.4701 44.17C74.5901 44.27 74.4901 44.3 74.4901 44.3Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.41 45.99C75.29 45.72 75.24 45.44 74.78 45.21C74.27 44.94 74.24 44.19 73.77 44.14C74.16 44.7 74.1 45.47 74.87 45.68C75.09 45.75 75.41 45.99 75.41 45.99Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0901 42.7401C73.1301 42.9301 73.4801 42.9901 73.6101 42.7701C73.6901 42.6401 73.5401 42.4301 73.3901 42.3701C73.1601 42.3001 73.0401 42.5401 73.0901 42.7401Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9901 44.93C74.9901 44.93 75.0901 44.65 75.1801 44.55C75.6201 43.92 75.2101 43.92 75.4301 42.91C75.0401 43.14 75.2501 43.59 75.0201 43.92C74.8301 44.19 75.0101 44.65 74.9901 44.93Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.02 45.31C75.1 44.76 74.58 44.21 74.75 43.89C74.92 43.57 75.33 42.32 74.08 42.03C74 42.01 74.89 43.28 74.57 43.69C74.23 44.12 75.03 42.19 73.04 41.85C73 41.84 73.69 42.49 73.78 42.99C73.86 43.49 74.41 43.76 74.27 43.91C74.21 43.98 73.88 43.23 73.27 42.71C73.27 42.71 73.06 43.65 74.21 44.14C74.21 44.14 74.45 44.12 74.51 44.62C74.54 44.88 74.82 45.5 74.82 45.5L75.02 45.31Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6001 44.95C74.4601 44.97 74.4001 45.2 74.5601 45.27C74.7401 45.35 74.8202 45.26 74.8302 45.18C74.8702 45.02 74.7501 44.93 74.6001 44.95Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9702 45.0601C76.1902 45.7101 75.7402 46.2701 75.3902 46.6801C75.0802 47.0401 75.1402 47.2101 75.1702 46.6901C75.1902 46.4501 75.1402 45.7001 75.7802 45.2001C75.9502 45.0701 75.9702 45.0601 75.9702 45.0601Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9002 46.14C75.3302 46.48 75.3202 46.88 75.1502 46.97C75.2602 46.43 75.9502 45.47 75.1802 44.56C75.1402 44.52 75.1802 44.46 74.9502 44.81C74.4302 45.63 74.7502 46.51 74.9002 46.88C74.9202 46.92 74.8502 47.16 74.8402 47.14C74.4802 46.48 74.7002 45.66 74.1302 45.48C73.8102 45.38 73.9602 45.38 74.0702 45.75C74.3602 46.71 73.9202 46.22 74.6202 47.53C74.3602 47.95 73.1502 49.94 73.1702 49.98C73.2902 50.32 73.8602 49.9 73.9302 49.61C73.9402 49.56 74.7602 47.85 75.0502 47.28C75.1602 47.29 75.2002 47.29 75.3602 47.22C75.9602 46.94 76.2902 46.45 76.2902 46.19C76.3202 45.65 76.4102 45.84 75.9002 46.14Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0901 47.18C74.9501 47.2 74.8801 47.44 75.0301 47.56C75.1201 47.63 75.2801 47.53 75.3301 47.43C75.4101 47.26 75.2401 47.16 75.0901 47.18Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4702 43.39C74.3302 43.41 74.2602 43.65 74.4102 43.77C74.5002 43.84 74.6602 43.74 74.7102 43.64C74.7902 43.48 74.6202 43.37 74.4702 43.39Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.71 46.72C74.53 46.74 74.45 47.06 74.63 47.2C74.74 47.29 74.95 47.16 75.02 47.03C75.12 46.83 74.91 46.7 74.71 46.72Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3402 47.4301C74.6802 48.0201 74.3602 48.6601 74.0902 49.1301C73.8602 49.5501 73.9402 49.7001 73.8702 49.1801C73.8402 48.9401 73.6502 48.2201 74.1702 47.6001C74.3102 47.4401 74.3402 47.4301 74.3402 47.4301Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1501 47.7001C75.0501 48.4901 74.4701 49.1201 73.9101 49.5001C73.4101 49.8401 73.4201 50.0601 73.6401 49.4401C73.7401 49.1501 74.0101 48.1201 74.9501 47.7101C75.1801 47.6001 75.1501 47.7001 75.1501 47.7001Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4102 48.79C75.1702 49.01 74.6202 49.82 74.0102 49.95C73.4702 50.07 73.4702 50.27 73.7302 49.79C73.8502 49.56 74.1902 48.72 75.1902 48.72C75.4502 48.71 75.4102 48.79 75.4102 48.79Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9102 47.6C74.1502 48.2 73.9302 48.94 73.6302 49.51C73.3602 50.01 73.4602 50.16 73.3802 49.61C73.3402 49.36 73.1402 48.5 73.7402 47.72C73.9002 47.51 73.9102 47.6 73.9102 47.6Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.05 51.1C72.86 49.95 72.5 49.62 73.06 49.32C73.62 49.02 73.63 49 73.57 49.21C73.5 49.42 73.56 50.42 72.6 50.86C72.34 50.97 72.05 51.1 72.05 51.1Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4602 51.14C71.9102 51.14 73.8202 51.22 73.6702 49.81C73.6702 49.77 73.2302 49.81 72.8202 50.12C72.3802 50.45 72.2402 50.93 72.0502 50.85C72.0102 50.84 72.6102 50.48 72.6702 49.51C72.6702 49.51 71.9602 49.53 71.8102 50.8C71.7702 51.1 70.7002 51.23 70.3202 51.3C68.3902 51.63 67.9102 52.14 67.9102 52.14C68.3202 52.05 68.6301 52.25 68.6301 52.25C69.1201 51.87 70.2702 51.61 70.8902 51.51C71.3102 51.44 72.2801 51.34 72.5901 51.4C72.9501 51.47 73.6701 51.26 74.0901 50.43C74.1101 50.35 73.0102 51.14 72.4602 51.14Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8301 50.07C73.4401 49.94 73.4501 50.34 73.6401 50.49C73.8201 50.64 74.3101 50.23 73.8301 50.07Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3401 49.1501C73.5201 48.8301 73.1701 48.7801 73.0101 48.9101C72.8501 49.0501 73.1101 49.5401 73.3401 49.1501Z",
    fill: "#52AB32",
    stroke: "#101010",
    strokeWidth: 0.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26626_59423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.63,
    height: 92.42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPy);
export default __webpack_public_path__ + "static/media/Flag_PY.e38500cec790bde71d203b2822f00917.svg";
export { ForwardRef as ReactComponent };